import { API_URL } from "./Helper";

export const getUserDetailsAPI = `${API_URL}user/userdetails`;
export const getPictureAPI = `${API_URL}user/userprofile`;